import React from "react";
import PropTypes from "prop-types";
import TableService from "../../../services/tableService";
import FilterTable from "../FilterTable";

export default function OfferTable(props) {
  const data = React.useMemo(
    () =>
      TableService.getPreparedDataForCollapsibleTable(
        props.tableConfig,
        props.data,
        props.hiddenColumns,
        props.columnsOrders,
        props.onClickMultipleLocationAlert,
        props.onClickPreview,
        props.onClickOfferNr
      ),
    [props.data, props.hiddenColumns, props.columnsOrders]
  );

  return (
    <FilterTable
      checkedAll={props.checkedAll}
      onClickRow={props.onClickRow}
      onClickCheck={props.onClickCheck}
      onClickCheckAll={props.onClickCheckAll}
      data={data}
      filteringData={props.filteringData}
      countRecords={props.countRecords}
      page={props.page}
      onPageChange={props.onPageChange}
      rowsPerPage={props.rowsPerPage}
      onRowsPerPageChange={props.onRowsPerPageChange}
      rowsPerPageOptions={props.rowsPerPageOptions}
      resetPageNumber={props.resetPageNumber}
      headersConfig={TableService.getHeadersConfigForCollapsibleTable(
        props.tableConfig,
        props.filteringData,
        props.hiddenColumns,
        props.columnsOrders
      )}
      selectedItemId={props.selectedOfferId}
      style={props.style}
      showCheckbox={props.showCheckbox}
      showTitle={props.showTitle}
      title={props.title}
      filterPrefix={props.filterPrefix}
      showFilters={props.showFilters}
      withPagination={props.withPagination}
      showCleanFilterIcon={props.showCleanFilterIcon}
      showContextMenu={props.showContextMenu}
      contextMenuActions={props.contextMenuActions}
      initialExpandedFilterHeader={props.initialExpandedFilterHeader}
      dataKeyToRunDetailsMethod={props.dataKeyToRunDetailsMethod}
      showFavorite={props.showFavorite}
      showDetailsIcon={props.showDetailsIcon}
      itemDetailsLinkPrefix={props.itemDetailsLinkPrefix}
      showExportToFileButton={props.showExportToFileButton}
      exportToFileUrl={props.exportToFileUrl}
      exportToFileSearchParams={props.exportToFileSearchParams}
      exportToFileHeaders={props.exportToFileHeaders}
      exportToFileFileName={props.exportToFileFileName}
      isLoading={props.isLoading}
      showTableLoader={props.showTableLoader}
    />
  );
}

OfferTable.propTypes = {
  ticketData: PropTypes.object,
  style: PropTypes.object,
  hiddenColumns: PropTypes.array,
  columnsOrders: PropTypes.array,
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  filterPrefix: PropTypes.string,
  showCheckbox: PropTypes.bool,
  showFilters: PropTypes.bool,
  showCleanFilterIcon: PropTypes.bool,
  withPagination: PropTypes.bool,
  onClickPreview: PropTypes.bool,
  initialExpandedFilterHeader: PropTypes.bool,
  showFavorite: PropTypes.bool,
  dataKeyToRunDetailsMethod: PropTypes.string,
  itemDetailsLinkPrefix: PropTypes.string,
};

OfferTable.defaultProps = {
  hiddenColumns: [],
  ticketData: [],
  showTitle: false,
  showCheckbox: false,
  showFilters: true,
  showCleanFilterIcon: true,
  withPagination: true,
  initialExpandedFilterHeader: false,
};
